export default __webpack_public_path__ + "static/media/seur-sm.a16c7ad0.svg";